/* istanbul ignore file */
export const DEFAULT_AUTH_COOKIE_NAME = 'cvent-auth';
/**
 * @deprecated Use getAuthCookieName() instead
 */
export const AUTH_COOKIE_NAME = process.env.AUTH_COOKIE_NAME || DEFAULT_AUTH_COOKIE_NAME;
export const CSRF_HEADER = 'X-Cvent-CSRF';
export const DEFAULT_CSRF_TOKEN_NAME = 'csrfToken';
/**
 * @deprecated Use getCsrfTokenName() instead
 */
export const CSRF_TOKEN_NAME = process.env.CSRF_TOKEN_NAME || DEFAULT_CSRF_TOKEN_NAME;
export function getAuthCookieName() {
    return process.env.AUTH_COOKIE_NAME || DEFAULT_AUTH_COOKIE_NAME;
}
export function getCsrfTokenName() {
    return process.env.CSRF_TOKEN_NAME || DEFAULT_CSRF_TOKEN_NAME;
}
//# sourceMappingURL=constants.js.map